import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';

import { onReset } from 'src/app/authentication/reset-reducer';
import * as userPasswordResetActions from './user-password-reset.actions';

export const userPasswordResetFeatureKey = 'userPasswordReset';

export interface UserPasswordResetState {
   callState: CallState;
}

export const initialState: UserPasswordResetState = {
   callState: LoadingState.Init,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),

   on(userPasswordResetActions.userPasswordResetSubmitted, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),

   on(userPasswordResetActions.userPasswordResetSuccess, userPasswordResetActions.userPasswordResetFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
